// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"132b4528","386":"6252c1d2"}[chunkId] + ".chunk.js";
};